<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" *ngIf="user.role == 'ROLE_ADMIN'"><a routerLink="/admin/adminDashboard/"
                                                                       *ngIf="user.role == 'ROLE_ADMIN'">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">Shipments</li>
    </ol>
  </nav>
  <div class="invalid-feedback d-block shift-invalid-text" [hidden]="!errorMessage">{{errorMessage}}</div>
  <div class="row align-items-center">
    <div class="col">
      <ul class="list-inline tab-list deskContent">
        <ng-container *ngFor="let om of ordersMainMenu">
          <li *ngIf="om.additional === 'N'" class="list-inline-item">
            <a (click)="populateTabData(om.tabClicked,om.orderStatus); tabChange();"
               [ngClass]="{'active': tabClicked === om.tabClicked}">{{om.displayName}}</a>
          </li>
        </ng-container>
      </ul>
      <select class="form-control MobileContent" id="use2r" [(ngModel)]="userDrop2"
              [ngModelOptions]="{standalone: true}" (change)="populate(userDrop2)" style="width: 140px;" required>
        <option *ngFor="let u of ordersMainMenu" [ngValue]="u.orderStatus" selected>{{u.displayName}}</option>
      </select>
    </div>
    <div class="col text-right">
      <button data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
              class="btn btn-outline-primary btn-sm dropdown-toggle ml-2 d-none-mobile"
              *ngIf="(checkedList?.length) && tabClicked !== 'all'">
        Actions
      </button>
      <div class="dropdown-menu dropdown-menu2  dropdown-menu-right ml-3"
           *ngIf="(checkedList?.length) && tabClicked !== 'all'">
        <a *ngIf="tabClicked === 'readyToShip'" [ngClass]="{'disabled':validToDisplay('Carrier to be assigned')}"
           (click)="shipMultipleOrders(orders)" class="dropdown-item file btn shift-import">Select the Carrier</a>
        <a *ngIf="tabClicked === 'readyToShip'" [ngClass]="{'disabled':validToDisplay('Generate Label')}"
           (click)="generateShippingLabel(orders)" class="dropdown-item file btn shift-import">Generate Shipping
          Label</a>
        <a *ngIf="tabClicked === 'readyToShip'" [ngClass]="{'disabled':validToDisplay('Label Generated')}"
           (click)="selectAwaitingCarrier(orders)" class="dropdown-item file btn shift-import">Request for Pickup</a>
        <a *ngIf="tabClicked === 'awaitingCarrier'" [ngClass]="{'disabled':validToDisplay('Awaiting Carrier')}"
           (click)="shipMultipleOrders(orders)" class="dropdown-item file btn shift-import">Reassign Shipment</a>
        <a *ngIf="tabClicked === 'awaitingCarrier'" [ngClass]="{'disabled':validToDisplay('Awaiting Carrier')}"
           (click)="moveToInTransit(orders)" class="dropdown-item file btn shift-import">Shipped</a>
        <a *ngIf="tabClicked === 'awaitingCarrier'" [ngClass]="{'disabled':validToDisplay('shipped')}"
           (click)="moveToShipped(orders)" class="dropdown-item file btn shift-import">Move to Delivered</a>
        <a *ngIf="tabClicked === 'awaitingCarrier' || tabClicked === 'completed'"
           [ngClass]="{'disabled':validToDisplay('shipped')}" (click)="returnOrders(orders)"
           class="dropdown-item file btn shift-import">Return Order</a>
      </div>

      <div>
        <button class="btn btn-primary m-1" style="border-radius: 10px" routerLink="/admin/updateOrderStatus/">Update Status</button>
      </div>

    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="inner-box d-none d-sm-block" [ngClass]="{'show-pagination':(!totalRecords || totalRecords<20)}"
           style="min-height:580px!important;">
        <table class="table" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
          <thead>
          <tr>
            <th></th>
            <th>Order#</th>
            <th>Channel Order#</th>
            <th width="200px;">Order Date</th>
            <th>Source</th>
            <th>Customer</th>
            <th>Contact</th>
            <th>Status</th>
            <th></th>
          </tr>
          </thead>
          <tbody class="table-body-custom">
          <tr *ngFor="let o of orders">
            <td [hidden]="tabClicked === 'exception' || tabClicked === 'all'">
              <div class="form-checkbox mr-3"><input
                type="checkbox" id="{{o.orderHeaderId}}" [(ngModel)]="o.isSelected"
                name="list_name" (change)="selectShip(o)"><label
                for="{{o.orderHeaderId}}"></label>
              </div>
            </td>
            <td>
              <a class="" routerLink="/admin/viewOrders/{{o.orderHeaderId}}">{{o.orderNumber}}
                <img placement="bottom" ngbTooltip="Demo Order" class="ml-1 mb-1" id="demo2"
                     src="assets/images/Demo.png" width="20" height="20" *ngIf="o.accountType == 'DEMO_ACCOUNT'"></a>
            </td>
            <td>{{o.sourceOrderId || '--'}}</td>
            <td width="200px;">{{(o.sourceOrderDate || o.orderedDate) | date: 'dd-MMM-yyyy'}}</td>
            <td>
              <div class="text-truncate" style="width:100px;">{{o.channelName | titlecase}}</div>
            </td>
            <td>
              <div class="text-truncate" style="width:100px; text-transform:capitalize;">{{o.ownerName}}</div>
            </td>
            <td>
              <div class="text-truncate" style="width:100px; text-transform:capitalize;">{{o.contactName}}</div>
            </td>
            <td>
              <div class="text-truncate"
                   title="{{(o.orderStatus == 'READY_TO_SHIP' ? 'Carrier to be assigned':
                   (o.orderStatus == 'SHIPPED' ? 'Shipped':
                                     (o.orderStatus == 'GENERATED' ? 'Generated':
                                     (o.orderStatus == 'AWAITING_CARRIER' ? 'Awaiting Carrier':
                                     (o.orderStatus == 'IN_TRANSIT' ? 'In Transit':
                                     (o.orderStatus == 'GENERATE_LABEL' ? 'Generate Label':
                                     (o.orderStatus == 'LABEL_GENERATED' ? 'Label Generated': o.orderStatus )))))))|titlecase}}"
                   style="width:100px;">{{(o.orderStatus == 'READY_TO_SHIP' ? 'Carrier to be assigned' :
                (o.orderStatus == 'SHIPPED' ? 'Shipped' :
                (o.orderStatus == 'GENERATED' ? 'Generated' :
                (o.orderStatus == 'AWAITING_CARRIER' ? 'Awaiting Carrier' :
                (o.orderStatus == 'IN_TRANSIT' ? 'In Transit' :
                (o.orderStatus == 'GENERATE_LABEL' ? 'Generate Label' :
                (o.orderStatus == 'LABEL_GENERATED' ? 'Label Generated' : o.orderStatus))))))) | titlecase}}
              </div>
            </td>
            <td>
              <div *ngIf="o.orderStatus == 'GENERATE_LABEL'
              || o.orderStatus == 'LABEL_GENERATED' || o.orderStatus == 'AWAITING_CARRIER' || o.orderStatus == 'SHIPPED'">
                <a routerLink="/admin/trackOutBoundOrder/{{o.orderHeaderId}}">
                  <img src="assets/images/dsBuffer.png" width="30" height="30" alt="trackImage">
                </a>
              </div>
            </td>
          </tr>
          </tbody>
          <tfoot>
          <tr *ngIf="orders?.length===0|| !orders?.length">
            <td colspan="8" class="text-center">No matching records found</td>
          </tr>
          </tfoot>
        </table>
      </div>
      <div class="inner-box d-block d-sm-none">
        <table class="table tablesaw  tablesaw-stack" data-tablesaw-mode="stack">
          <thead>
          <tr>
            <th>Order#</th>
            <th width="200px;">Order Date</th>
            <th>Customer</th>
            <th>Contact</th>
            <th>Warehouse</th>
            <th width="200px;"
                [hidden]="tabClicked === 'readyToShip'">
              Ship Date
            </th>
            <th width="200px;"
                [hidden]="tabClicked === 'readyToShip'">
              AWB Number
            </th>
            <th>Status</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let o of orders">
            <td>
              <b class=" tablesaw-cell-label">Order#</b>
              <span class="tablesaw-cell-content"><a class=""
                                                     routerLink="/admin/viewOrders/{{o.orderHeaderId}}">{{o.orderNumber}}
                <img placement="bottom" ngbTooltip="Demo Order" class="ml-1 mb-1" id="demoo2"
                     src="assets/images/Demo.png" width="20" height="20"
                     *ngIf="o.accountType == 'DEMO_ACCOUNT'"></a></span>
            </td>
            <td width="200px;"><b class=" tablesaw-cell-label">Order Date</b>
              <span class="tablesaw-cell-content">{{o.orderedDate}}</span>
            </td>
            <td><b class=" tablesaw-cell-label">Customer</b>
              <span class="tablesaw-cell-content" style="text-transform:capitalize;">{{o.ownerName}}</span>
            </td>
            <td><b class=" tablesaw-cell-label">Contact </b>
              <span class="tablesaw-cell-content" style="text-transform:capitalize;">{{o.contactName}}</span>
            </td>
            <td><b class=" tablesaw-cell-label">Warehouse </b>
              <span class="tablesaw-cell-content">{{o.warehouseName}}</span>
            </td>
            <td><b class=" tablesaw-cell-label">Source</b>
              <span class="tablesaw-cell-content">{{o.channelName | titlecase}}</span>
            </td>
            <td width="200px;" *ngIf="o.shippedDate !== null"
                [hidden]="tabClicked === 'readyToShip'">
              <b class=" tablesaw-cell-label">Ship Date </b>
              <span class="tablesaw-cell-content">{{o.shippedDate}}</span>
            </td>
            <td width="200px;" *ngIf="o.awbNumber !== null"
                [hidden]="tabClicked === 'readyToShip'">
              <a href="/" data-toggle="modal" data-target="#orderDetails" (click)="trackByAWB(o.awbNumber)"><b
                class=" tablesaw-cell-label">AWB Number</b>
                <span class="tablesaw-cell-content">{{o.awbNumber}}</span></a>
            </td>
            <td>
              <b class=" tablesaw-cell-label">Status</b>
              <span
                class="tablesaw-cell-content">{{(o.orderStatus == 'READY_TO_SHIP' ? 'Carrier to be assigned' :
                (o.orderStatus == 'SHIPPED' ? 'Shipped' :
                (o.orderStatus == 'GENERATED' ? 'Generated' :
                (o.orderStatus == 'AWAITING_CARRIER' ? 'Awaiting Carrier' :
                (o.orderStatus == 'IN_TRANSIT' ? 'In Transit' :
                (o.orderStatus == 'GENERATE_LABEL' ? 'Generate Label' :
                (o.orderStatus == 'LABEL_GENERATED' ? 'Label Generated' : o.orderStatus))))))) | titlecase}}</span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</section>


<div [ngStyle]="{'display': pdfGenerate =='Y'? 'block' : 'none'}" style="overflow-y:auto"
     [ngClass]="{'modal': pdfGenerate == 'Y'}" class="modal" id="popUpHold" tabindex="-1" role="dialog"
     aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog snk-modal-dialog-45 modal-dialog-centered" role="document">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <h5 class="modal-title w-100" id="exampleHoldLabel">Select Size</h5>
        <button type="button" id="enterQuantity" class="close" (click)="close()" aria-label="Close">
          <svg id="close-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
            <g id="Close-Icon-2" data-name="Close-Icon" transform="translate(16.263 0) rotate(45)">
              <path id="Line_4" data-name="Line 4" d="M1,0V22" transform="translate(10.5 0.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Line_6" data-name="Line 6" d="M0,1H22" transform="translate(0.5 10.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>
          <div class="row">
            <div class="col-8">
              <div class="form-group required">
                <label class="control-label" for="printSize2">Print Size Option</label>
                <select class="form-control" id="printSize2" [(ngModel)]="size" [ngModelOptions]="{standalone: true}"
                        [ngClass]="{'is-invalid':sizeError}" required>
                  <option>A4</option>
                  <option>A5</option>
                  <option>Custom</option>
                </select>
                <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!sizeError">{{sizeError}}</div>
              </div>
            </div>
            <div class="col-4 mt-4 text-right">
              <button type="submit" class="btn btn-orange ml-1" (click)="printShipment()">Submit</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
